<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <el-drawer title="" :visible.sync="open_seat_plan" direction="btt" size="95%" :destroy-on-close="true" :before-close="getBooking">
      <div class="" v-if="booking && accommodation" style="padding: 20px">
        <vessel-seat-plan-form :accommodation="accommodation" :vessel_detail="booking.vessel" :booking="booking"
          :allow_block="true"></vessel-seat-plan-form>
      </div>
    </el-drawer>


    <form @submit.prevent="handleSubmit(submit)" class="text-black-form">
      <div class="card ticket-form-card">
        <div class="card-header">
          <h4 class="card-title">
            {{ form.id ? 'Update Ticket' : 'Create Ticket' }}
          </h4>
          <el-alert effect="dark" :closable="false" type="warning" v-if="isAdvanceBooking()">ADVANCE BOOKING
            {{$moment(form.booking_date).format('YYYY-MM-DD')}}</el-alert>
          <el-alert effect="dark" :closable="false" type="warning" v-if="isAdvanceBooking('back')">PAST DATE BOOKING
            {{$moment(form.booking_date).format('YYYY-MM-DD')}}</el-alert>
        </div>
        <div class="card-body">

          <div class="row">
            <div class="col-md-12">
              <el-checkbox v-model="default_name" @change="setDefaultName">Default Name</el-checkbox>
            </div>
            <div class="col-md-9">
              <div class="form-group">
                <label>Passenger Name</label>
                <ValidationProvider name="full_name" rules="required" v-slot="{ passed, failed }">
                  <fg-input type="text" :error="failed ? 'Passenger name is required' : null" :hasSuccess="passed"
                    class="capital-letter bold-text-blue super-bold" name="full_name" v-model="form.full_name">
                  </fg-input>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Age</label>
                <el-input v-model="form.age" type="number"></el-input>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <div class="form-group">
                <label>Contact Number</label>
                <el-input v-model="form.contact_number" type="number"></el-input>
              </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Gender</label>
                <ValidationProvider name="gender" v-slot="{ passed, failed }">
                  <el-select v-model="form.gender" placeholder="Select Gender" filterable
                    class="form-group bold-text-blue super-bold" :class="[
                { 'has-danger': failed },
                { 'has-success': passed }]">
                    <el-option :value="p" :label="p" v-for="p, i in $store.state.gender_list" :key="i">{{ p
                      }}</el-option>
                  </el-select><br>
                  <span class="error-text" v-if="failed">Gender is required</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Passenger Type</label>
                <ValidationProvider name="passenger_type" rules="required" v-slot="{ passed, failed }">
                  <el-select v-model="form.passenger_type" placeholder="Select" filterable
                    class="form-group bold-text-blue super-bold" :class="[
    { 'has-danger': failed },
    { 'has-success': passed }]">
                    <el-option :value="i" :label="p" v-for="p, i in $store.state.passenger_types" :key="i">{{ p
                      }}</el-option>
                  </el-select><br>
                  <span class="error-text" v-if="failed">Passenger type is required</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="row">

            <div class="col-md-4">
              <div class="form-group">
                <label>Accommodation</label>
                <ValidationProvider name="accommodation" rules="required" v-slot="{ passed, failed }">
                  <el-select v-model="form.accommodation_id" placeholder="Select" filterable
                    class="form-group bold-text-blue super-bold" :class="[
                { 'has-danger': failed },
                { 'has-success': passed }]">
                    <el-option :value="accommodation.id" :label="accommodation.name"
                      v-for="accommodation in accommodations" :key="accommodation.id">{{ accommodation.name
                      }}</el-option>
                  </el-select><br>
                  <span class="error-text" v-if="failed">Accommodation is required</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-4" v-if="booking">
              <div class="form-group">
                <label>Trip Type</label>
                <ValidationProvider name="type" rules="required" v-slot="{ passed, failed }">
                  <el-select v-model="form.type" placeholder="Select" class="form-group bold-text-blue super-bold"
                    :class="[
                    { 'has-danger': failed },
                    { 'has-success': passed }]">
                    <el-option :value="t.id" :label="t.label" v-for="t in $store.state.ticket_types" :key="t.id">{{
                      t.label
                      }}</el-option>
                  </el-select><br>
                  <span class="error-text" v-if="failed">Type is required</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="col-md-4">
              <div v-if="form.type != 2">
                <label>Open roundtrip return ?</label><br>
                <el-switch v-model="form.is_open" active-text="Yes" inactive-text="No">
                </el-switch>
              </div>
            </div>



          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Booking Date</label>
                <ValidationProvider name="booking_date" rules="required" v-slot="{ passed, failed }">
                  <el-date-picker v-model="form.booking_date" type="date" placeholder="Pick a day"
                    class="form-group bold-text-blue super-bold" :class="[
                { 'has-danger': failed },
                { 'has-success': passed }]">
                  </el-date-picker>
                  <br><span class="error-text" v-if="failed">Booking Date is required</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Route</label>
                <ValidationProvider name="route" rules="required" v-slot="{ passed, failed }">
                  <el-select v-model="form.route_code" placeholder="Select" filterable
                    class="form-group bold-text-blue super-bold" :class="[
                    { 'has-danger': failed },
                    { 'has-success': passed }]">
                    <el-option :value="route.code" :label="route.code" v-for="route in routes" :key="route.code">{{
                      route.code
                      }}</el-option>
                  </el-select><br>
                  <span class="error-text" v-if="failed">Route is required</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Booking Time</label>
                <ValidationProvider name="route" rules="required" v-slot="{ passed, failed }">
                  <el-select v-model="form.time" placeholder="Select" filterable
                    class="form-group bold-text-blue super-bold" :class="[
                { 'has-danger': failed },
                { 'has-success': passed }]">
                    <el-option :value="trip.time" :label="trip.formatted_time" v-for="trip in trips" :key="trip.time">{{
                      trip.formatted_time
                      }}</el-option>
                  </el-select><br>
                  <span class="error-text" v-if="failed">Time is required</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-12"></div>

            <div class="col-md-4" v-if="form.type == 2 && booking">
              <div class="form-group">
                <label>Return Date</label>
                <ValidationProvider name="return_date" :rules="isRequired('type')" v-slot="{ passed, failed }">
                  <el-date-picker v-model="form.return_date" type="date" placeholder="Pick a day"
                    class="form-group bold-text-blue super-bold" :class="[
    { 'has-danger': failed },
    { 'has-success': passed }]" :picker-options="pickerOptions">
                  </el-date-picker>
                  <br><span class="error-text" v-if="failed">Return Date is required</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="col-md-4" v-if="form.type == 2 && booking">
              <div class="form-group">
                <label>Return Time</label>
                <ValidationProvider name="return_time" :rules="isRequired('type')" v-slot="{ passed, failed }">
                  <el-select v-model="form.return_time" placeholder="Select" filterable
                    class="form-group bold-text-blue super-bold" :class="[
                    { 'has-danger': failed },
                    { 'has-success': passed }]">
                    <el-option :value="trip.time" :label="trip.formatted_time" v-for="trip in return_trips"
                      :key="trip.time">{{ trip.formatted_time
                      }}</el-option>
                  </el-select><br>
                  <span class="error-text" v-if="failed">Return time is required</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-12"></div>
            <div class="col-md-8">
              <div class="form-group">
                <label>Promo</label>
                {{ promo_item ? promo_item.promo.name : ''}}
                <el-select 
                    v-model="promo_item_id"
                    @change="overridePrice"
                    clearable
                    placeholder="Select Promo"
                    class="form-group bold-text-blue super-bold"
                    name="promo_item"
                  >
                    <el-option
                      v-for="item in promo_items"
                      :key="item.id"
                      :value="item.id"
                      :label="item.promo.name + ' | ' + money(item.amount)"
                    />
                  </el-select>
                <br>
              </div>
            </div>

            <div class="col-md-12" v-if="booking">
              <el-button type="warning" plain @click="handleOpenSeatPlan()">OPEN {{ booking.vessel.code }} {{
                getAccommodationLabel() }} SEAT PLAN</el-button>
            </div>

            <div class="col-md-12">
              <hr>
              <div>
                <div v-if="price">
                  <el-descriptions class="margin-top bold-text-blue" title="Summary" :column="3" size="mini" border v-if="booking">
                    <el-descriptions-item label-class-name="my-label">
                      <template slot="label">
                        Booking Info
                      </template>
                      {{ booking.vessel.code }}
                    </el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label">
                      <template slot="label">
                        Total Capacity
                      </template>
                      {{ booking.data.total_capacity }}
                    </el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label">
                      <template slot="label">
                        Total Available
                      </template>
                      {{ booking.data.available_slots }}
                    </el-descriptions-item>
                  </el-descriptions>

                  <el-descriptions class="margin-top bold-text-blue" :column="3" size="mini" border v-if="booking"
                    v-for="(accommodation,i) in booking.data.accommodations" :key="i"
                  >
                    <el-descriptions-item>
                      <template slot="label">
                        Accom
                      </template>
                      {{ accommodation.code }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label">
                        Capacity
                      </template>
                      {{ accommodation.total_capacity }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label">
                        Available
                      </template>
                      {{ accommodation.available_slots  }}
                    </el-descriptions-item>
                  </el-descriptions>

                  <br v-if="return_booking">
                  <el-descriptions class="margin-top bold-text-blue" v-if="return_booking" :column="3" size="mini" border >
                    <el-descriptions-item >
                      <template slot="label">
                        Return Vessel
                      </template>
                      {{ return_booking.vessel.code }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label">
                        Capacity
                      </template>
                      {{ return_booking.capacity }}
                    </el-descriptions-item>
                    <el-descriptions-item >
                      <template slot="label">
                        Available
                      </template>
                      {{ return_booking.capacity - return_booking.total_passengers }}
                    </el-descriptions-item>
                  </el-descriptions>

                 <div v-if="return_booking">
                   <el-descriptions class="margin-top bold-text-blue" :column="3" size="mini" border v-if="return_booking && return_booking.data"
                    v-for="(accommodation,i) in return_booking.data.accommodations" :key="i"
                  >
                    <el-descriptions-item>
                      <template slot="label">
                        Accom
                      </template>
                      {{ accommodation.code }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label">
                        Capacity
                      </template>
                      {{ accommodation.capacity }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label">
                        Available
                      </template>
                      {{ accommodation.available_slots  }}
                    </el-descriptions-item>
                  </el-descriptions>

                 </div>

                  <br>
                  <el-descriptions class="margin-top bold-text-blue" title="" :column="3" size="mini" border v-if="booking">
                    <el-descriptions-item v-if="booking">
                      <template slot="label">
                        FCA
                      </template>
                      {{ money(booking.route.origin.fca) }} <span v-if="return_booking">+{{
                        money(return_booking.route.origin.fca) }}</span>
                    </el-descriptions-item>

                    <el-descriptions-item>
                      <template slot="label">
                        TF
                      </template>
                      {{ money(0) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label">
                        <i class="el-icon-money"></i>
                        Fare
                      </template>
                      {{ money(form.amount) }}
                    </el-descriptions-item>
                    <el-descriptions-item v-if="return_booking">
                      <template slot="label">
                        <i class="el-icon-money"></i>
                        Return Fare
                      </template>
                      <span v-if="return_price">{{ money(return_price.amount) }}</span>
                    </el-descriptions-item>
                  </el-descriptions>

                  <el-descriptions class="margin-top" title="" :column="1" size="mini" border>

                    <el-descriptions-item>
                      <template slot="label">
                        Total Fare
                      </template>
                      <span style="font-size: 40px;font-weight: bold;"> {{ form.is_open ? money(over_all_fare*2)
                        :money(over_all_fare) }}</span>

                    </el-descriptions-item>

                  </el-descriptions>

                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="card-footer text-right">
          <el-button type="primary" native-type="submit" :disabled="!price && !form.booking"
            size="large">ADD</el-button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {
  extend
} from "vee-validate";
import {
  required
} from "vee-validate/dist/rules";
import {
  Ticket
} from '@/resources/ticket'
import {
  Accommodation
} from '@/resources/accommodation'
import {
  Route
} from '@/resources/route'

import {
  Booking
} from '@/resources/booking'

import {
  PromoItem
} from '@/resources/promo_item'
import moment from 'moment';
import VesselSeatPlanForm from '../Vessels/VesselSeatPlanForm.vue';

extend("required", required);

export default {
  components: { VesselSeatPlanForm },
  props: ['ticket', 'update'],
  data() {
    return {
      form: {
        booking_date: new Date(),
        full_name: null,
        passenger_type: 0,
        gender: 'MALE',
        accommodation_id: null,
        route_code: null,
        time: null,
        type: 1,
        return_date: null,
        return_time: null,
        return_route_code: null,
        return_booking_id: null,
        age: '',
        contact_number: ''
      },
      open_seat_plan: false,
      promo_item: null,
      promo_item_id: null,
      trips: [],
      return_trips: [],
      accommodations: [],
      accommodation: null,
      routes: [],
      capacity: 0,
      total_passengers: 0,
      price: null,
      booking: null,
      return_booking: null,
      return_capacity: 0,
      return_total_passengers: 0,
      return_price: null,
      promo_items: [],
      over_all_fare: 0,
      default_name: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      }
    };
  },
  watch: {
    update() {
      // this.form.booking_date = this.$moment().format('YYYY-MM-DD')
    },
    ticket: function () {
      console.log('test')
      if (this.ticket) this.form = Object.assign({}, this.ticket)
    },
    'form.is_open': function () {
      console.log(this.form.is_open)
    },
    'form.type': function () {
      if (this.form.type == 2) {
        this.form.return_date = this.form.booking_date
        this.form.is_open = false
      } else {
        this.form.return_date = null
        this.form.return_time = null
        this.form.return_booking_id = null
        this.return_booking = null
        if (this.form.route_code && this.form.time) this.getBooking()
      }
    },
    'form.booking_date': function () {
      // this.form.route_code = null
      if (this.form.type == 2) {
        this.form.return_date = this.form.booking_date
      } else {
        this.form.return_date = null
        this.form.return_time = null
        this.form.return_booking_id = null
        this.return_booking = null
      }
      this.clearData()
      this.getRoutes()
    },
    'form.return_date': function () {
      this.form.return_time = null
      this.form.return_booking_id = null
      this.return_booking = null
      this.getReturnTrips()
    },
    'form.return_time': function () {
      this.getReturnBooking()
    },
    'form.route_code': function () {
      this.form.time = null
      this.booking = null
      this.getTrips()
    },
    'form.time': function () {
      if (this.form.route_code && this.form.time) {
        this.getBooking()

        if (this.form.type == 2) {
          this.form.return_time = null
          this.form.return_booking_id = null
          this.return_booking = null
          this.getReturnTrips()
        }
      }
    },
    'form.accommodation_id': function () {
      if (this.form.route_code && this.form.time) {
        this.getBooking()
      }
    },
    'form.passenger_type': function () {
      if (this.form.route_code && this.form.time) {
        this.getBooking()
      }
    }
  },
  created: function () {
    if (this.ticket) this.form = Object.assign({}, this.ticket)
    this.getAccommodations()
  },
  beforeDestroy() {
    this.form = {
      code: "",
      name: "",
    }
  },
  methods: {
    handleOpenSeatPlan() {
      this.open_seat_plan = true
    },
    isAdvanceBooking(option) {
      let dateNow = this.$moment().format('YYYY-MM-DD')
      let bookingDate = this.$moment(this.form.booking_date).format('YYYY-MM-DD')
      return option ? bookingDate < dateNow :  bookingDate > dateNow
    },
    setDefaultName() {
      if (this.default_name) this.form.full_name = "PASSENGER"
    },
    overridePrice() {
      this.promo_item = null
      let self = this
      this.promo_items.forEach(function(promo_i){
        if (promo_i.id == self.promo_item_id) self.promo_item = promo_i
      })
      this.form.amount = this.promo_item ? this.promo_item.amount : this.price.amount
      this.form.promo_item_id = this.promo_item ? this.promo_item.id : null
      this.computeOverAllFare()
    },
    isRequired(field) {
      if (field == 'type') {
        return this.form.type == 2 ? 'required' : ''
      }
      return ''
    },
    checkReturnTrips() {
      this.getReturnTrips()
    },
    clearData() {
      this.booking = null
      this.price = null
      this.capacity = 0
      this.total_passengers = 0
      this.form.booking_id = null
    },
    submit() {

      if (this.form.age && parseInt(this.form.age) > 110) {
        this.$notify({
          type: 'danger',
          title: "Error",
          text: 'Age is invalid',
        });
        return;
      }
      this.$loading = true


      this.form.promo_item_id = this.promo_item ? this.promo_item.id : null

      let request = this.form.id ? Ticket.update(this.form) : Ticket.create({
        tickets: [this.form]
      })

      request
        .then(result => {
          this.$notify({
            type: 'success',
            title: "Success",
            text: 'Ticket has been saved',
          });
          this.form.full_name = this.default_name ? "PASSENGER" : ""
          this.form.age = ""
          this.form.gender = ""
          this.capacity = result.data.capacity
          this.total_passengers = result.data.total_passengers
          this.getBooking()
          if (this.form.type == 2) {
            this.getReturnBooking()
          }

          this.$emit('save', true)
        })
        .catch(error => {

        }).finally(() => {
          this.$loading = false
        })
    },
    computeOverAllFare() {
      this.over_all_fare = this.price.amount
      if (this.form.type == 2 && this.return_price) this.over_all_fare += this.return_price.amount
      if (this.promo_item) {
        this.over_all_fare = this.promo_item.amount
        if (this.promo_item.promo.is_round_trip === 1) this.over_all_fare += this.promo_item.return_trip_amount
        if (this.promo_item.promo.is_round_trip === 2 && this.form.type == 2) {
          this.over_all_fare += this.promo_item.amount
        }
      }

      if (this.booking) this.over_all_fare += this.booking.route.origin.fca
      if (this.return_booking) this.over_all_fare += this.return_booking.route.origin.fca
    },
    getBooking() {
      this.open_seat_plan = false
      let time = this.form.time
      if (!this.form.booking_date) return
      if (!time) return

      this.$loading = true
      this.promo_items = []
      this.form.amount = 0
      this.form.promo_item = null
      this.form.promo_item_id = null
      this.clearData()
      Booking.getBooking({
          date: this.$moment(this.form.booking_date).format('YYYY-MM-DD'),
          route_code: this.form.route_code,
          time: time,
          accommodation_id: this.form.accommodation_id,
          passenger_type: this.form.passenger_type,
          include_price: true,
          is_round_trip: this.form.type == 2,
          check_only: true
        })
        .then(result => {
          if (result.data.booking) this.booking = result.data.booking
          this.form.booking_id = result.data.booking.id
          this.capacity = result.data.capacity
          this.total_passengers = result.data.total_passengers
          this.price = result.data.price

          this.form.return_booking_id = null
          this.return_booking = null
          this.return_capacity = 0
          this.return_total_passengers = 0
          this.return_price = 0
          this.findAvailablePromos()
          if (this.form.type == 2) {
            this.getReturnBooking()
          }
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
    getReturnBooking() {

      if (!this.form.return_date) return
      this.$loading = true
      this.form.return_booking_id = null
      this.return_booking = null
      this.return_capacity = 0
      this.return_total_passengers = 0
      this.return_price = 0

      Booking.getBooking({
          date: this.$moment(this.form.return_date).format('YYYY-MM-DD'),
          route_code: this.form.return_route_code,
          time: this.form.return_time,
          accommodation_id: this.form.accommodation_id,
          passenger_type: this.form.passenger_type,
          include_price: true
        })
        .then(result => {
          if (result.data.booking)
            this.return_booking = result.data.booking
          this.form.return_booking_id = result.data.booking.id
          this.return_capacity = result.data.capacity
          this.return_total_passengers = result.data.total_passengers
          this.return_price = result.data.price
          this.findAvailablePromos()
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
    getTrips() {
      this.trips = []
      if (!this.form.booking_date) return
      if (!this.form.route_code) return
      this.$loading = true
      this.form.time = null
      Booking.getTrips({
          date: this.$moment(this.form.booking_date).format('YYYY-MM-DD'),
          route_code: this.form.route_code,
          per_page: 999,
        time_only: true,
          open_only: 1
        })
        .then(result => {
          if (result.data.trips)
            this.trips = result.data.trips
          // this.checkIfTripAvailableFirst()
          if (this.trips.length) this.form.time = this.trips[0].time
        })
        .catch(() => {
          if (this.form.type == 2) this.form.type = 1
          this.booking = null
          this.form.amount = 0
        }).finally(() => {
          this.$loading = false
        })
    },
    checkIfTripAvailableFirst() {
      if (this.trips.length) {
        let time = this.trips[0].time
      }
    },
    getReturnTrips() {
      this.return_trips = []
      if (!this.form.return_date) return
      if (this.form.return_date < this.form.booking_date) {
        this.$notify({
          type: 'error',
          title: "Error",
          text: 'Return date must not be earlier than the booking date',
        });
        this.form.return_date = null
        return
      }
      if (!this.form.route_code) return
      this.$loading = true
      Booking.getTrips({
          date: this.$moment(this.form.return_date).format('YYYY-MM-DD'),
          route_code: this.form.route_code,
          per_page: 999,
          time_only: true,
          origin_date: this.$moment(this.form.booking_date).format('YYYY-MM-DD'),
          origin_time: this.form.time,
          return_time: true
        })
        .then(result => {
          if (result.data.trips)
            this.return_trips = result.data.trips
          if (this.return_trips.length) this.form.return_time = this.return_trips[0].time
          this.form.return_route_code = result.data.return_route_code
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
    getRoutes() {
      this.$loading = true
      this.form.route_code = null
      Booking.getRoutes({
          date: this.$moment(this.form.booking_date).format('YYYY-MM-DD'),
          per_page: 999
        })
        .then(result => {
          if (result.data.routes)
            this.routes = result.data.routes
          if (this.routes.length) this.form.route_code = this.routes[0].code
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
    getAccommodationLabel() {
      let selected = null
      let accom_id = this.form.accommodation_id
      this.accommodations.forEach(function (accom) {
        if (accom_id == accom.id) selected = accom
      })

      this.accommodation = selected
      return selected ? selected.name : null
    },
    getAccommodations() {
      this.$loading = true
      Accommodation.get({})
        .then(result => {
          if (result.data.accommodations)
            this.accommodations = result.data.accommodations
          if (this.accommodations.length) this.form.accommodation_id = this.accommodations[0].id

          this.getRoutes()
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
    findAvailablePromos() {
      if (this.price) this.form.amount = this.price.amount
      this.promo_items = []
      this.form.promo_item = null
      this.promo_item = null
      this.$loading = true
      PromoItem.findAvailablePromos({
        is_round_trip: this.form.type == 2 ? 1 : 0,
        price_id: this.price.id
      })
        .then(result => {
          this.promo_items = result.data.promo_items
          this.computeOverAllFare()
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    }
  }
}
</script>

<style scoped>
.my-label {
    background: #E1F3D8;
  }

</style>
